import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import AdminBannerSortList from "./AdminBannerSortList";

// State
import { addRoute } from "../../../store/actions/route";
import { setpageTitle } from "../../../store/actions/siteInfo";

// CSS
import "../../../css/sortable.css";

class AdminBannerSort extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Set Banner Order");
	}

	render() {
		return (
			<div>
				<h1>Set Banner Order</h1>

				<div className="margin_bottom">
					Drag and drop the various banners you have and hit "Submit" when complete!
				</div>

				<AdminBannerSortList />
			</div>
		);
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminBannerSort);



// WEBPACK FOOTER //
// ./src/components/admin/banners-sort/AdminBannerSort.js